import Vue from "vue";

export default {
	state: {
		inviteDetails: {
			country: "Brasil",
			personType: 2,
			inviteLanguageId: 1
		},
		protocolDetails: {
			IdItem: null,
			IdMaterial: null,
			IdClient: null,
			CodeERP: "",
			Manufacturer: "",
			PartNumber: "",
			DescriptionShort: "",
			DescriptionLong: "",
			AttachedFile: "",
			SelectedApplication: "",
			SelectedWorkflow: "",
			Companies: [],
			Families: [],
			Status: ""
		},
		invites: [],
		invitesPagination: {},
		supplierEmail: {},
		inviteFields: []
	},
	mutations: {
		setInviteOnState(state, inviteDetails) {
			state.inviteDetails = mapInviteSupplierDetails(inviteDetails);
		},
		setProtocolInviteOnState(state, protocolDetails) {
			state.protocolDetails = mapProtocolInviteDetails(protocolDetails);
		},
		setSupplierEmailOnState(state, supplierEmail) {
			state.supplierEmail = supplierEmail;
		},
		cleanInvite(state) {
			state.inviteDetails = {
				country: "Brasil",
				personType: 2,
				inviteLanguageId: 1
			};
		},
		setInvitesOnState(state, invites) {
			state.invites = mapInvites(invites);
		},
		setInvitesPaginationOnState(state, invitesPagination) {
			state.invitesPagination = invitesPagination;
		},
		setInviteFieldsOnState(state, inviteFields) {
			state.inviteFields = inviteFields;
		}
	},
	actions: {
		getInvite({ commit }, idInvite) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("invite/", idInvite)
					.then((response) => {
						this.state.loading = false;
						const { inviteModelType } = response.data.data;
						const { CUSTOMER, MATERIAL } = Vue.prototype.$InviteModelType;

						if (inviteModelType == CUSTOMER) commit("setInviteOnState", response.data.data);
						else if (inviteModelType == MATERIAL) commit("setProtocolInviteOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getInvitesBy({ commit }, filters) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("invite/supplier", filters)
					.then((response) => {
						commit("setInvitesOnState", response.data.data.invites);
						commit("setInvitesPaginationOnState", response.data.data.pagination);
						this.state.loading = false;
						resolve();
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getInvitesByUser({ commit }, filters) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("invite/all/user", filters)
					.then((response) => {
						commit("setInvitesOnState", response.data.data.invites);
						commit("setInvitesPaginationOnState", response.data.data.pagination);
						this.state.loading = false;
						resolve();
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		createInviteSupplier(_, inviteSupplier) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("invite/createSupplier", inviteSupplier)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch((e) => {
						this.state.loading = false;
						reject(e);
					});
			});
		},
		createInviteMaterial(_, inviteMaterial) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("invite/createMaterial", inviteMaterial)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch((e) => {
						this.state.loading = false;
						reject(e);
					});
			});
		},
		createInviteKlassmattSIN(_, payload) {
			const { isIframeContext = false } = payload;
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("invite/createSinKlassmatt", payload, { isIframeContext })
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((e) => {
						this.state.loading = false;
						reject(e);
					});
			});
		},
		cancelInvite(_, invite) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.post("invite/cancel", invite).then((response) => {
					this.state.loading = false;
					resolve(response);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		resendInviteEmail(_, inviteEmailObject) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("invite/email/resend", inviteEmailObject)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((e) => {
						this.state.loading = false;
						reject(e);
					});
			});
		},
		getSupplierEmailConfiguration({ commit }, { cnpjCpf, nif, stateRegistration, municipalRegistration }) {
			const queryParams = { cnpjCpf, nif, stateRegistration, municipalRegistration };
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("supplier/check", queryParams)
					.then((response) => {
						commit("setSupplierEmailOnState", response.data.data);
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						console.error(error);
					});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		deleteInvite(_, idInvite) {
			this.state.loading = true;
			let data = {};
			data.idInvite = idInvite;
			return new Promise((resolve) => {
				Vue.prototype.$http.delete("invite/" + idInvite).then((response) => {
					this.state.loading = false;
					resolve(response.data.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		supplierUpdateEmail(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("invite/update", data)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		createSupplierEmail(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("invite/email", data)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		acceptInvite(_, idInvite) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put(`invite/${idInvite}/accept`)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getInviteFields({ commit }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("invite/fields")
					.then((response) => {
						this.state.loading = false;
						commit("setInviteFieldsOnState", response.data.data.inviteFields);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		}
	},

	getters: {
		invites({ invites }) {
			return invites;
		},
		inviteDetails({ inviteDetails }) {
			return inviteDetails;
		},
		protocolDetails({ protocolDetails }) {
			return protocolDetails;
		},
		invitesPagination({ invitesPagination }) {
			return invitesPagination;
		},
		supplierEmail({ supplierEmail }) {
			return supplierEmail;
		},
		inviteFields({ inviteFields }) {
			return inviteFields;
		}
	}
};

const mapInvites = (invites) => {
	let mappedInvites = [];
	invites.forEach((invite) => {
		invite.actualStepList.forEach((actualStep) => {
			//Caso tenha mais de 1 etapa atual, é um fluxo paralelo
			if (invite.actualStepList.length > 1) {
				invite.isParallel = true;
			} else {
				invite.isParallel = false;
				invite.actualStep = actualStep;
			}
			mappedInvites.push(invite);
		});
	});

	return mappedInvites;
};

const mapInviteSupplierDetails = (inviteDetails) => {
	let mappedInviteDetails = {
		country: inviteDetails.supplier.country,
		address: inviteDetails.supplier.address,
		zipCode: inviteDetails.supplier.zipCode,
		complement: inviteDetails.supplier.addressComplement,
		corporationName: inviteDetails.supplier.corporationName,
		number: inviteDetails.supplier.addressNumber,
		district: inviteDetails.supplier.district,
		city: inviteDetails.supplier.city,
		country: inviteDetails.supplier.country,
		uf: inviteDetails.supplier.uf,
		personType: inviteDetails.supplier.personType,
		supplierName: inviteDetails.supplier.supplierName || inviteDetails.supplierName,
		stateRegistration: inviteDetails.supplier.stateRegistration,
		municipalRegistration: inviteDetails.supplier.municipalRegistration,
		cnpjCpf: inviteDetails.cnpjCpf,
		nif: inviteDetails.cnpjCpf,
		flowType: inviteDetails.idWorkflowType,
		idWorkflow: inviteDetails.idWorkflow,
		email: inviteDetails.supplier.supplierEmail.email,
		inviteEmail: inviteDetails.supplier.supplierEmail.inviteEmail,
		idSupplier: inviteDetails.supplier.idSupplier,
		birthDate: inviteDetails.supplier.birthDate,
		familiesId: inviteDetails.family,
		companiesId: inviteDetails.company,
		requesterCPF: inviteDetails.requesterCPF,
		message: inviteDetails.message,
		supplierParent: inviteDetails.supplier.idSupplierParent,
		inviteParentEmail: inviteDetails.supplier.inviteParentEmail,
		status: inviteDetails.status,
		attach: inviteDetails.attach,
		sendAttachmentEmailInvitation: inviteDetails.sendAttachmentEmailInvitation,
		nameContact: inviteDetails.supplier.supplierContact.name,
		sector: inviteDetails.supplier.supplierContact.sector,
		emailContact: inviteDetails.supplier.supplierContact.email,
		phoneContact: inviteDetails.supplier.supplierContact.phone,
		cellphoneContact: inviteDetails.supplier.supplierContact.cellphone,
		nameBank: inviteDetails.supplier.supplierBank.name,
		bankDescription: inviteDetails.supplier.supplierBank.bank,
		agencyDescription: inviteDetails.supplier.supplierBank.agency,
		account: inviteDetails.supplier.supplierBank.account,
		accountType: inviteDetails.supplier.supplierBank.accountType,
		stateRegistration: inviteDetails.supplier.stateRegistration,
		municipalRegistration: inviteDetails.supplier.municipalRegistration,
		inviteType: inviteDetails.supplier.inviteType,
		sendCopyInviteEmail: inviteDetails.sendCopyInviteEmail,
		inviteLanguageId: inviteDetails.inviteLanguageId
	};
	return mappedInviteDetails;
};

const mapProtocolInviteDetails = (protocolDetails) => {
	const mappedProtocolInviteDetails = {
		IdItem: protocolDetails.material.idItem,
		IdMaterial: protocolDetails.material.idMaterial,
		IdClient: protocolDetails.material.idClient,
		CodeERP: protocolDetails.material.codeERP,
		Manufacturer: protocolDetails.material.manufacturer,
		PartNumber: protocolDetails.material.partNumber,
		DescriptionShort: protocolDetails.material.descriptionShort,
		DescriptionLong: protocolDetails.material.descriptionLong,
		AttachedFile: protocolDetails.attach,
		SelectedApplication: protocolDetails.idWorkflowType,
		SelectedWorkflow: protocolDetails.idWorkflow,
		Companies: protocolDetails.company,
		Families: protocolDetails.family,
		Status: protocolDetails.status
	};

	return mappedProtocolInviteDetails;
};
